module.exports = __webpack_public_path__ + "static/media/LinePattern.f1517017.svg";